import React from 'react';
// @ts-ignore
import styles from './ManagerCertificates.module.scss';
import Text from '../../../../../../Components/Base/Text/Text';
import ManagerCertificatesList from '../ManagerCertificatesList/ManagerCertificatesList';
import ManagerServicesList from '../ManagerServicesList/ManagerServicesList';

interface Props {}

const ManagerCertificates: React.FC<Props> = () => {
	return (
		<div className={styles.wrapper}>
			<Text
				tx='base.certificatesOfHealthCompany'
				className={styles.title}
				firstUpper
			/>
			<ManagerCertificatesList />
			<hr />
			<Text tx='base.service' className={styles.title} firstUpper />
			<ManagerServicesList />
		</div>
	);
};

export default ManagerCertificates;
